import { SERVICE_HOST } from "../utils/auth/config";

/* eslint-disable */
export const ROSTER_BY_SECTION = `${SERVICE_HOST}/teacher-info/v0/section`; // <sectionId>/index.json
export const TEACHER_SECTIONS = `${SERVICE_HOST}/teacher-info/v0`; // <username>/index.json
/* eslint-enable */
